import { MdModeEditOutline } from "react-icons/md";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const SearchBar = ({
  addClientPath,
  editClientPath,
  onSearch,
  showEditButton,
  titleOne,
  showAddButton,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const clientId = searchParams.get("clientId"); // "details"

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchValue); // Manual trigger
  };

  const handleAddClient = () => {
    if (clientId)
      return navigate(`${addClientPath}?clientId=${clientId}`);
    navigate(addClientPath);
  };

  const handleEditClient = () => {
    navigate(editClientPath);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    onSearch(value); // Trigger on every change (typing + backspace)
  };

  return (
    <div className="block md:flex md:justify-between justify-center items-center py-4 pr-4">
      <form className="max-w-md w-full mb-6" onSubmit={handleSubmit}>
        <label
          htmlFor="default-search"
          className="mb-2 text-sm font-medium text-gray-900 sr-only"
        >
          Search
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <svg
              className="w-4 h-4 text-[#045B9B]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
              />
            </svg>
          </div>
          <input
            type="search"
            id="default-search"
            className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg focus:outline-none"
            placeholder="Search by name"
            value={searchValue}
            onChange={handleChange} // LIVE search
          />
          <button
            type="submit"
            className="text-white absolute end-2.5 bottom-2.5 bg-[#045B9B] hover:bg-[#23567a] focus:outline-none font-medium rounded-lg text-sm px-4 py-2"
          >
            Search
          </button>
        </div>
      </form>

      <div className="flex mb-6">
        {showAddButton && (
          <button
            onClick={handleAddClient}
            className="flex items-center justify-center px-4 py-2 text-white bg-[#045B9B] rounded hover:bg-[#23567a] mr-2 text-sm w-full md:w-auto"
          >
            <AiOutlinePlus className="mr-2" /> {titleOne}
          </button>
        )}

        {showEditButton && (
          <button
            onClick={handleEditClient}
            className="flex items-center justify-center px-4 py-2 text-white bg-[#045B9B] rounded hover:bg-[#23567a] mr-2 text-sm w-full md:w-auto"
          >
            <MdModeEditOutline className="mr-2" /> Edit Client
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
